import React from "react";
import { isValid } from "date-fns";
import { Mui } from "@osu/react-ui";
import { inputMappings } from "../../../util/enums";
import DatePicker from "./DateUtil/DatePicker";
import TimePicker from "./DateUtil/TimePicker";
import DateTimeGroup from "./DateUtil/Group";

function DateTime(props = {}) {
  const {
    id,
    value:  currentValue,
    type,
    onChange,
    className,
    placeholder,
    startTime,
    endTime,
    validation,
    helperText,
    error,
    required = false,
    description,
    descriptionProps = {},
    ...rest
  } = props;

  let value = null;
  if (isValid(currentValue)) {
    value = currentValue;
  } else if (currentValue) {
    const parsedDate = new Date(currentValue);
    if (isValid(parsedDate)) {
      value = parsedDate;
    }
  }

  let sharedProps = {
    id,
    onChange: (value) => {
      onChange({
        id,
        value,
      });
    },
    className,
    value,
    ...rest,
  };
  if(type === inputMappings.datetime) {
    return <DateTimeGroup {...props} {...sharedProps} value={currentValue} />
  }
  if (type === inputMappings.time) {
    return <TimePicker {...sharedProps} slotProps={{ textField: { error: (!!error), helperText: (error ?? ""), required } }} />;
  }

  return (
    <Mui.FormControl className={className}>
      {description && <Mui.Typography className="margin-bottom-1" variant="body2" {...descriptionProps}>{description}</Mui.Typography>}
      <DatePicker {...sharedProps} slotProps={{ textField: { error: (!!error), helperText: (error ?? ""), required } }} />
    </Mui.FormControl>
  );
}

DateTime.defaultProps = {
  value: null,
};

export default DateTime;
